import { MdOutlineInbox } from 'react-icons/md';
import classnames from 'classnames';

const ICON_SIZE_MAP = {
  md: {
    size: 32,
    padding: 'p-4',
  },
  lg: {
    size: 56,
    padding: 'p-6',
  },
};

type ListEmptyStateProps = {
  message: string;
  iconBgClass?: string;
  iconColorClass?: string;
  iconSize?: 'md' | 'lg';
};

export const ListEmptyState = ({
  message,
  iconBgClass = 'bg-white',
  iconColorClass = 'text-base-50',
  iconSize = 'md',
}: ListEmptyStateProps) => {
  const iconStyles = ICON_SIZE_MAP[iconSize];

  return (
    <div className="w-full flex flex-col items-center justify-center gap-4 py-12">
      <div
        className={classnames(
          'flex items-center justify-center rounded-full',
          iconStyles.padding,
          iconBgClass,
          iconColorClass,
        )}
      >
        <MdOutlineInbox size={iconStyles.size} />
      </div>
      <span className="text-l-r text-base-25">{message}</span>
    </div>
  );
};
